import React from 'react';
import { FinalBannerState } from '../../../../enums/FinalBannerState';
import FinalBannerBeforeAnnouncement from './variants/FinalBannerBeforeAnnouncement/FinalBannerBeforeAnnouncement';
import FinalBannerBeforeAnnouncementCharedi from './variants/FinalBannerBeforeAnnouncementCharedi/FinalBannerBeforeAnnouncementCharedi';
import FinalBannerAfterUnidentified, { FinalBannerAfterUnidentifiedCharedi } from './variants/FinalBannerAfterUnidentified/FinalBannerAfterUnidentified';
import FinalBannerAfterAdvanced from './variants/FinalBannerAfterAdvanced/FinalBannerAfterAdvanced';
import FinalBannerAfterNotAdvanced from './variants/FinalBannerAfterNotAdvanced/FinalBannerAfterNotAdvanced';
import FinalBannerAfterPublishFinalWinners from './variants/FinalBannerAfterPublishFinalWinners/FinalBannerAfterPublishFinalWinners';
import classes from './FinalBanner.module.css';

const COMPONENT_MAP = {
  [FinalBannerState.beforeAnnouncement]: FinalBannerBeforeAnnouncement,
  [FinalBannerState.beforeAnnouncementCharedi]: FinalBannerBeforeAnnouncementCharedi,
  [FinalBannerState.afterUnidentified]: FinalBannerAfterUnidentified,
  [FinalBannerState.afterAdvanced]: FinalBannerAfterAdvanced,
  [FinalBannerState.afterNotAdvanced]: FinalBannerAfterNotAdvanced,
  [FinalBannerState.afterUnidentifiedCharedi]: FinalBannerAfterUnidentifiedCharedi,
  [FinalBannerState.afterPublishFinalWinners]: FinalBannerAfterPublishFinalWinners,
};

const FinalBanner = ({ bannerState }) => {
  const Component = COMPONENT_MAP[bannerState];
  if (!Component) {
    return null;
  }
  return (
    <div className={classes.finalBanner}>
      <Component />
    </div>
  );
};

export default FinalBanner;
